import IsLoading from "@/components/layouts/IsLoading";
import SetLinks from "@/components/layouts/SetLinks";
import Show from "@/components/layouts/Show";
import SourceDataFindingsAdd from "@/components/lists/findings/SourceDataFindingsAdd";
import SourceDataFindingsList from "@/components/lists/findings/SourceDataFindingsList";
import TrialContext from "@/contexts/data/TrialContext";
import { SourceDataFindingsInstitutionCreateLink, SourceDataFindingsParticipantCreateLink, SourceDataFindingsTrialCreateLink } from "@/contexts/layouts/LinkContext";
import useTrialSourceDataFindings from "@/hooks/data/useTrialSourceDataFindings";
import { Typography } from "@mui/material";
import { FC, useContext } from "react";

const TrialSourceDataFindingsAdd: FC = () => {
    const { data: trial } = useContext(TrialContext);

    return (
        <>
            <SetLinks 
                createTrialLink={SourceDataFindingsTrialCreateLink} 
                createInstitutionLink={SourceDataFindingsInstitutionCreateLink} 
                createParticipantLink={SourceDataFindingsParticipantCreateLink}  
            />
            <Show show={true}>
                <Typography variant="h1" gutterBottom>
                    Findings
                </Typography>
                <SourceDataFindingsAdd trialId={trial?.id} />
            </Show>
        </>
    )
};

export default TrialSourceDataFindingsAdd;